import { DIMENSION_IDS } from '@/constants'
import { computed, unref } from 'vue'
import { createListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'
import { useDimension } from './dimension'
import { useFramework } from '@/composables/useFramework'

export const useCompareDimension = createSharedComposable(() => {
    const { framework, isGdpCorrelation } = useFramework()

    const dimension = useDimension()

    const frameworkList = computed(() => {
        return unref(framework)
            .filter(({ parent }) => parent === undefined)
            .map(({ name, id }) => ({
                label: name,
                value: id as string | undefined
            }))
    })

    const list = computed(() => {
        return unref(frameworkList).filter(({ value }) => {
            return value !== unref(dimension)
        })
    })

    const defaultValue = computed(() => {
        return isGdpCorrelation(unref(dimension))
            ? DIMENSION_IDS.GOV_RESPONSE
            : undefined
    })

    return createListQuery('compare-dimension', list, {
        defaultValue
    })
})
